import { service } from "."

export default {
  sendMessage: (body) => service.post("/connectings/web", body),
}
